module.exports = __webpack_public_path__ + "static/img/null.cda83db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/null.png
// module id = CKCW
// module chunks = 3